import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonIt from './locales/it/common.json';
import landingIt from './locales/it/landing.json';
import signupIt from './locales/it/signup.json';

/**
 * Lingue supportate dal marketplace.
 * MVP: solo italiano. Architettura predisposta per estensione futura.
 * Vedi: docs/superpowers/specs/2026-05-15-marketplace-fv-design.md sezione 4.7
 */
export const SUPPORTED_LOCALES = ['it'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'it';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: {
        common: commonIt,
        landing: landingIt,
        signup: signupIt,
      },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    nonExplicitSupportedLngs: true,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React già sanitizza
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'marketplace.locale',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
